import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        appid: "",
        server_host: "",
        server_port: "",
        user: "",
        password: "",
        from_name: "",
        subject: "",
        tpl: ""
      },
      rules: {
        appid: [{
          required: true,
          message: "请选择应用",
          trigger: "blur"
        }],
        server_host: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        server_port: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        user: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        from_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        subject: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        tpl: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getcommonData(['appListAllData']);

              case 2:
                _this.copyPrimitive();

                if (data) {
                  _this.formData = _objectSpread({}, data);
                  _this.formData.tpl = _this.$utils.textRepl(_this.formData.tpl);
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 10;
                    break;
                  }

                  if (!_this2.formData.id) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return _this2.secondConfirmation();

                case 4:
                  data = JSON.parse(JSON.stringify(_this2.formData));
                  data.tpl = data.tpl.replaceAll(_this2.$imgUrl, '');
                  reqFn = _this2.formData.id ? 'appEmailCodeConfigUpdate' : 'appEmailCodeConfigAdd';

                  _this2.$api[reqFn](_objectSpread(_objectSpread({}, data), {}, {
                    isMustAppid: 1
                  })).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  });

                  _context2.next = 11;
                  break;

                case 10:
                  return _context2.abrupt("return", false);

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};